import {
  HistoricoLoteItem,
  fx_createHistoricoLoteGetListService,
} from "../../../../../modulos/pesaje/ganaderia/services/HistoricoLoteGetListService";
import { ClienteFincaLoteResponse } from "../../../../../modulos/terceros/response/ClienteFincaLoteResponse";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import { CompraDetailModalRender } from "../modal/CompraDetailModalRender";
import { HistoricoLoteListItemRender } from "../list/HistoricoLoteListItemRender";
import { RotacionPesajeVeterinariaDetailModalRender } from "../modal/RotacionPesajeVeterinariaDetailModalRender";
import { VentaDetailModalRender } from "../modal/VentaDetailModalRender";

/** Contador para ids únicos por instancia. */
let HISTORICO_LOTE_ID = 0;

/** Contenido del modal de histórico de un lote: card con una fila por
 *  movimiento (compras, ventas y eventos RPV), con estados cargando/vacío/error
 *  y el detalle del registro fuente al ver una fila. */
export class HistoricoLoteRender implements IConnectRender {
  /** Id del contenedor de filas (único por instancia). */
  private readonly _rowsId: string;

  /** @param _lote Lote cuyo histórico se muestra. */
  constructor(private readonly _lote: ClienteFincaLoteResponse) {
    HISTORICO_LOTE_ID += 1;
    this._rowsId = `historico-lote-rows-${HISTORICO_LOTE_ID}`;
  }

  /** Card con el contenedor de filas (con el padding del detail body). */
  render(): string {
    return `<div class="sx-detail-body"><div class="sx-list-card"><div class="sx-list-rows" id="${this._rowsId}"></div></div></div>`;
  }

  /** Captura el contenedor e inicia la carga. */
  connect(): void {
    this._rowsEl = document.getElementById(this._rowsId);
    void this._load();
  }

  /** Marca disposed y dispone las filas. */
  dispose(): void {
    this._disposed = true;
    this._disposeItems();
  }

  /** Contenedor de filas (disponible tras `connect`). */
  private _rowsEl: HTMLElement | null = null;
  /** Componentes-fila vivos. */
  private _items: IConnectRender[] = [];
  /** `true` tras `dispose()`: corta el render si la carga termina después. */
  private _disposed = false;

  /** Carga los movimientos y pinta filas o el estado correspondiente. */
  private async _load(): Promise<void> {
    if (!this._rowsEl) return;
    this._setMessage("Cargando…");
    try {
      const items = await fx_createHistoricoLoteGetListService(
        this._lote.id,
      ).getListAsync();
      if (this._disposed) return;
      this._renderItems(items);
    } catch {
      if (this._disposed) return;
      this._setMessage("Error al cargar la información.");
    }
  }

  /** Crea, inyecta y conecta una fila por movimiento (o el mensaje vacío). */
  private _renderItems(items: HistoricoLoteItem[]): void {
    this._disposeItems();
    if (!this._rowsEl) return;
    if (items.length === 0) {
      this._setMessage("Sin movimientos registrados");
      return;
    }
    this._items = items.map(
      (item) =>
        new HistoricoLoteListItemRender(item, (i) => this._openDetail(i)),
    );
    this._rowsEl.innerHTML = this._items.map((c) => c.render()).join("");
    this._items.forEach((c) => c.connect());
  }

  /** Abre el detalle del registro fuente según el tipo de movimiento. */
  private _openDetail(item: HistoricoLoteItem): void {
    if (item.tipo === "compra") {
      new CompraDetailModalRender(item.compra).init();
    } else if (item.tipo === "venta") {
      new VentaDetailModalRender(item.venta).init();
    } else {
      new RotacionPesajeVeterinariaDetailModalRender(item.evento).init();
    }
  }

  /** Dispone y descarta las filas vivas. */
  private _disposeItems(): void {
    this._items.forEach((c) => c.dispose());
    this._items = [];
  }

  /** Muestra un mensaje de estado (cargando/vacío/error). */
  private _setMessage(text: string): void {
    if (this._rowsEl) {
      this._rowsEl.innerHTML = `<div class="sx-list-empty">${text}</div>`;
    }
  }
}
